import { Directive, ElementRef, EventEmitter, HostListener, Output, AfterViewInit, OnInit } from "@angular/core";

@Directive({
    selector: "[horizontal-scroll]"
})
export class HorizontalScroll implements AfterViewInit{
    constructor(
        private elementRef: ElementRef
    ) {}

    ngAfterViewInit(){
        this.elementRef.nativeElement.addEventListener("mousewheel", e=>{
            this.scrollHorizontally(e, this.elementRef)
        }, false);
        this.elementRef.nativeElement.addEventListener("DOMMouseScroll", e=>{
            this.scrollHorizontally(e, this.elementRef)
        }, false);
    }

    scrollHorizontally(e, elementRef) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
      var scrollSpeed = 60; // Janky jank <<<<<<<<<<<<<<
      elementRef.nativeElement.scrollLeft -= (delta * scrollSpeed);
      //document.body.scrollLeft -= (delta * scrollSpeed);
      e.preventDefault();
    }
}